<template>
  <div class="page-wrapper">
    <v-col cols="12" lg="10" md="7">
      <v-form>
        <v-card class="card-shadow bg-secondary">
          <CadastroPromocao />
        </v-card>
      </v-form>
    </v-col>
  </div>
</template>



<script>
import CadastroPromocao from "./../Components/Cadastros/CadastroPromocao.vue";
export default {
  name: "RegisterPromo",
  components: {
    CadastroPromocao,
  },
  data() {
    return {};
  },
};
</script>
<style lang='scss' scoped>
.page-wrapper {
  display: flex;
  justify-content: center;
}
</style>
